define('views/pages/CheckoutOpcPageView',['underscore', 'jquery', 'PageView', 'app', 'hooks',
    'TagCommander',
    'models/CheckoutModel',
    'views/pages/checkout/CheckoutStepCartView',
    'views/pages/checkout/CheckoutStepCrossSellingView',
    'views/pages/checkout/CheckoutStepPaymentView',
    'views/blocks/checkout/ComeInInformationsView',
    'template!checkout-opc',
    'template!blocks/checkout/submit',
    'template!blocks/checkout/nav-customer',
    'template!blocks/checkout/cart-footer',
], function (_, $, PageView, app, hooks,
             TagCommander,
             CheckoutModel,
             CheckoutStepCartView,
             CheckoutStepCrossSellingView,
             CheckoutStepPaymentView,
             ComeInInformationsView,
             checkoutTemplate,
             submitTemplate,
             navCustomer,
             cartFooter
) {

    var checkoutModel,
        currentCheckoutStepView,
        submitBottom,
        pageName = 'CheckoutOpc';

    return PageView.extend({
        pageName: pageName,
        hideMobileCart: true,
        hideFooter: true,
        displayAsModal: true,
        events: {
            'click .btn-close':'clickClose',
            'click .btn-back':'clickBack',
            'click .checkout-opc__submit':'clickSubmit',
            'click .earn-cagnotte.component-comein':'openPopinComein',
            'click .display-popin':'clickOnButton',
        },

        initialize: function (options) {

            var view = this,
                cart = app.getCart();
            // PageView constructor heritage
            currentCheckoutStepView = false;
            PageView.prototype.initialize.apply(view, arguments);
            if(options.el){
                options.step_rewrite = view.$('.checkout-opc').data('step_rewrite');
            }

            checkoutModel = new CheckoutModel(options);

            view.listenTo(checkoutModel, 'change:current_step', view.onChangeStep);
            view.listenTo(checkoutModel, 'submitLoading', view.onSubmitLoading);
            view.listenTo(app,'openDialogCheckout',view.openDialogCheckout);
            view.listenTo(app,'cancelOptinRgpd',view.cancelOptinRgpd);
            view.listenTo(app.getCustomer(),'login logout',view.updateCustomerState);
            view.listenTo(cart,'change:total_price_ttc change:cagnotte',view.updateCartPriceTotal);
            view.listenTo(cart,'productsChange',view.onChangeCartQuantity);
            view.listenTo(cart,'empty unavailable',view.render);
            cart.checkProducts(true);
            view.render();
            if(app.isDesktop()){
                submitBottom = view.$('.checkout-opc__nav--bottom');
                view.listenTo(app,'change:scrollTop',view.onScroll);
            }
        },
        clickOnButton:function(){
            var productBoostModal = new ProductBoostModalView();
            app.displayModal(productBoostModal);
        },
        onScroll:function(app,scrollTop){
            submitBottom.toggleClass('visible',scrollTop>10)
        },
        clickClose:function(){
            this.close();
        },
        close:function(){
            this.trigger('close',this);
        },
        clickSubmit:function(){
            checkoutModel.nextStep();
        },
        clickBack:function(){
            if(checkoutModel.getCurrentStepIndex()===0){
                this.close();
            }else{
                checkoutModel.nextStep(1);
            }
        },
        onChange:function () {
            this.render();
        },
        onChangeStep:function(){
           this.startStep();
        },
        microtemplate: function (options) {
            this.pageOptions = _.defaults(options,{});;
            checkoutModel.set(options);
        },

        updateCustomerState: function (customer) {
            var view = this,
                isLogged = checkoutModel.isLogged();

            // permet de tracker sur TagCo le retour sur la page checkout
            // après la modal d'autentification
            // et à chaque view.startStep();
            view.trackOrderStep();

            view.$('.customer-fullname')
                .attr('data-logged',isLogged?1:0)
                .find('.value').text(checkoutModel.getFullname());
            view.$('.customerGroup-icon__wrapper').html(checkoutModel.getComeinIcon())
            view.$('.checkout-opc__nav--bottom').toggleClass('hidden',!isLogged && checkoutModel.isCurrentStep('payment'));
        },

        onSubmitLoading:function(isLoading){
            this.$('.checkout-opc__submit')
                .toggleClass('loading',isLoading)
                .attr('disabled',isLoading);
        },

        startStep:function(){
            var view = this,
                steps = checkoutModel.getSteps(),
                currentStep = checkoutModel.getCurrentStep(),
                previousCheckoutStepView = currentCheckoutStepView;
            if(previousCheckoutStepView){
                previousCheckoutStepView.remove();
            }
            app.scrollTop(0);
            var displayBackButton = true;
            switch(currentStep.id){
                default:
                case 'cart':
                    displayBackButton = false;
                    currentCheckoutStepView = new CheckoutStepCartView();
                    break;
                case 'cross_selling':
                    currentCheckoutStepView = new CheckoutStepCrossSellingView();
                    break;
                case 'payment':
                    currentCheckoutStepView = new CheckoutStepPaymentView();
                    break;
            }

            view.$('.btn-close').toggleClass('inactive',displayBackButton);
            view.$('.btn-back').toggleClass('inactive',!displayBackButton);

            view.updateCustomerState();

            steps.each(function(step){
                var $el = view.$('.checkout-opc__nav__link[data-id="'+step.id+'"]');
                $el.toggleClass('active',step.active);
                $el.toggleClass('on',step.active || step.prev);
            });

            view.attachView(currentCheckoutStepView);
            view.$('.checkout-opc__submit__label').text(currentStep.submitLabel);

            currentCheckoutStepView.init(checkoutModel);
            view.$('.checkout-opc__content').append(currentCheckoutStepView.$el);
            view.$('.checkout-opc__content').append(currentCheckoutStepView.$el);
            currentCheckoutStepView.afterInitialize(checkoutModel);
            hooks.execHook('hookCheckoutCagnottageDataView', {
                cart: checkoutModel.getCart(),
                view: view,
                selector: '.checkout-cagnottage-block.cagnottage-footer-checkout',
                context: 'footerCheckout',
            });

        },

        render: function () {
            var view = this;
            //
            view.$el.html(
                checkoutTemplate(checkoutModel)
            );
            view.startStep();
            view.initializeLinksOfPage();
        },

        openDialogCheckout: function(dialogCheckoutView){
            app.displayModal(dialogCheckoutView);
        },

        cancelOptinRgpd: function(){
            if(app.getCustomer().requireRgpdOptin()){
                checkoutModel.nextStep(true);
            }
        },

        updateCartPriceTotal: function () {
            this.$('.checkout-opc__submit__price').text(checkoutModel.formatPriceTotal());
        },

        onChangeCartQuantity: function () {
            var cart = app.getCart(),
                qty = cart.getQuantity();
            this.$('.checkout-opc__submit').attr('data-quantity',qty);
        },

        trackOrderStep:function(){
            TagCommander.LoadPage(pageName,{order_step:checkoutModel.getOrderStep()});
        },

        startPageTagCommander:function(page,options){
            // do nothing
        },
        openPopinComein: function() {
            var modalView = new ComeInInformationsView()
            modalView.overlay = 'translucent'
            if (app.c('_COMEIN_INFORMATIONS_DISPLAY_')) {
                app.displayModal(modalView)
            }
        },
    });
});

